import { SECOND_PAYMENT_DATE, SecondPaymentDueDateField } from '@makemydeal/dr-dash-components';
import { DealTabs } from '@makemydeal/dr-shared-types';

import { useSecondPaymentDateField } from '../../../../baseDealActivity/baseDealContainer/hooks/useSecondPaymentDateField';
import { useScenarioCellId } from '../../../hooks/useScenarioCellId';
import { ScenarioRow } from '../../ScenarioRow';

export const SecondPaymentDateRow = () => {
    const { value, onChange } = useSecondPaymentDateField();
    const cellId = useScenarioCellId('secondPaymentDate');

    return (
        <ScenarioRow rowKey="secondPaymentDate" label={SECOND_PAYMENT_DATE}>
            <SecondPaymentDueDateField
                id={`${DealTabs.SUMMARY}-${cellId}`}
                value={value}
                showStyledLabel
                onChange={onChange}
                size="sm"
            />
        </ScenarioRow>
    );
};
